import "./DashboardBrighterScoreProgressBar.scss"
import React from "react";

const DashboardBrighterScoreProgressBar = ({ percentage, title}) => {
    return (
        <div className="progress-container">
            <div
                className="circular-progress"
                style={{
                    background: `conic-gradient(
                        rgb(69, 204, 206) ${percentage}%, 
                        #f0f0f0 ${percentage}%
                    )`
                }}
            >
                <div className="inner-circle">
                    <div className="progress-value">{percentage}%</div>
                    <div className="progress-title">{title}</div>
                </div>
            </div>
        </div>
    );
}

export default DashboardBrighterScoreProgressBar;
